import axios from "axios";

export const state = {
    personalShiftReport: [],
    cashflow: [],
    income: [],
    payment_report: [],
    service_demand: [],
    single_result: [],
    all_results: [],
    daily_pay_report: [],
    visit_report: {},
    facility_visit_report: {},
    labperformancereport: [],
    facility_value_report_status: false,
    incomplete_dosage: [],
    atenatal_report: [],
    atenatal_report_status: false,
    antenatal_visit_report: [],
    print_report_anteid: "",
    single_email_msg: "",
    single_email_status: false,
    all_email_msg: "",
    all_email_status: false,
    payments: [],
    patient_payments: [],
    prescription_report: [],
    discount_report: [],
    diagnosis_report: [],
    graphsData: {},
    DepgraphsData: [],
    positivity: {},
    test_positivity: {},
    visit_report_status:false,
    dispensed_report:[],
    test_result_details:{},
    result_save_status:false,
    expense_cat_analysis:[],
    exp_cat_status:false
};
export const getters = {
    Expense_Cat_Analysis:state => state.expense_cat_analysis,
    resultSaveStatus:state => state.result_save_status,
    visitReport_status: state => state.visit_report_status,
    Exp_cat_status: state => state.exp_cat_status,
    TestResultDetails: state => state.test_result_details,
    personalShiftReport: state => state.personalShiftReport.data,
    DiscountReport: state => state.discount_report.data,
    PrintAntenatalVisitReportG: state => state.antenatal_visit_report.data,
    AntenatalVisitReport: state => state.atenatal_report,
    AntenatalReportStatus: state => state.atenatal_report_status,
    lab_performance_report: state => state.labperformancereport.data,
    Cashflow: state => state.cashflow,
    Income: state => state.income,
    PaymentReport: state => state.payment_report,
    FacilityVisitReport: state => state.facility_visit_report,
    DailyPayReport: state => state.daily_pay_report,
    ServiceDemand: state => state.service_demand,
    SingleResult: state => state.single_result,
    AllResults: state => state.all_results,
    IncompleteDosage: state => state.incomplete_dosage,
    FacilityValueReportStatus: state => state.facility_value_report_status,
    VisitReport: state => state.visit_report[0],
    Getprint_report_anteid: state => state.print_report_anteid,
    SingleEmailStatus: state => state.single_email_status,
    SingleEmailMsg: state => state.all_email_msg,
    AllEmailStatus: state => state.all_email_status,
    AllEmailMsg: state => state.all_email_msg,
    PaymentsReport: state => state.payments.data,
    PatientPaymentsReport: state => state.patient_payments.data,
    PrescriptionReport: state => state.prescription_report.data,
    DispensedReport: state => state.dispensed_report.data,
    DiagnosisReport: state => state.diagnosis_report.data,
    graphData: state => state.graphsData,
    DepgraphData: state => state.DepgraphsData,
    PositivityData: state => state.positivity,
    TestPositivityData: state => state.test_positivity,


};
export const mutations = {
    SET_ANTENATAL_VISIT_REPORT: (state, newValue) => state.atenatal_report = newValue.data,
    
    SET_INCOMPELETE_DOSAGE_REPORT: (state, newValue) => state.incomplete_dosage = newValue.data,
    SET_FACILITY_VISIT_REPORT: (state, newValue) => state.facility_visit_report = newValue.data,
    SET_FACILITY_VISIT_REPORT_STATUS: (state, newValue) => state.personalShiftReport = newValue,
    SET_PERSONAL_SHIFT_REPORT: (state, newValue) => state.personalShiftReport = newValue,
    SET_CASHFLOW: (state, newValue) => state.cashflow = newValue,
    SET_INCOME: (state, newValue) => state.income = newValue,
    SET_PRINT_ANTENATAL_VISIT_REPORT: (state, newValue) => state.antenatal_visit_report = newValue,
    SET_PAYMENT_REPORT: (state, newValue) => state.payment_report = newValue,
    SET_DAILY_PAY_REPORT: (state, newValue) => state.daily_pay_report = newValue,
    SET_SERVICE_ANALYSIS: (state, newValue) => state.service_demand = newValue,
    SET_SINGLE_RESULT: (state, newValue) => state.single_result = newValue,
    SET_ALL_RESULT: (state, newValue) => state.all_results = newValue,
    SET_VISIT_REPORT: (state, newValue) => state.visit_report = newValue,
    SET_EXPESE_CAT_ANALYSIS: (state, newValue) => state.expense_cat_analysis = newValue,
    SET_EXPESE_CAT_ANALYSIS_FILTER: (state, newValue) => state.expense_cat_analysis = newValue,
    SET_FACILITYVISITREPORTSTATUS: (state, newValue) => state.facility_value_report_status = newValue,
    SET_LAB_PERFORMANCE_REPO: (state, newValue) => state.labperformancereport = newValue,
    SET_SINGLE_RESULT_EMAIL_STATUS: (state, newValue) => state.single_email_status = newValue,
    SET_EXPESE_CAT_ANALYSIS_STATUS: (state, newValue) => state.exp_cat_status = newValue,
    SET_SINGLE_RESULT_EMAIL_MSG: (state, newValue) => state.single_email_msg = newValue,
    SET_ALL_RESULT_EMAIL_STATUS: (state, newValue) => state.all_email_status = newValue,
    SET_PRESCRIPTION_REPORT: (state, newValue) => state.prescription_report = newValue,
    SET_DISCOUNT_REPORT: (state, newValue) => state.discount_report = newValue,
    SET_DIAGNOSIS_REPORT: (state, newValue) => state.diagnosis_report = newValue,
    SET_GRAPH: (state, newValue) => state.graphsData = newValue,
    SET_DEP_GRAPH: (state, newValue) => state.DepgraphsData = newValue,
    SET_POSITIVITY: (state, newValue) => state.positivity = newValue,
    SET_TEST_POSITIVITY: (state, newValue) => state.test_positivity = newValue,
    SET_VISIT_REPORT_STATUS: (state, newValue) => state.visit_report_status =  newValue,
    SET_DISPENSED_REPORT: (state, newValue) => state.dispensed_report =  newValue,
    CLEAR_TEST_RESULT_DETAIL: (state) => state.test_result_details = {},
    SET_TEST_RESULT_DETAIL: (state, newValue) => state.test_result_details = newValue,
    SET_VISIT_REPORT_Temp (state) {
    state.visit_report = [{
        "clinic_id": null,
        "clinic_name": "",
        "clinic_address": "",
        "clinic_contact": "",
        "clinic_email": "",
        "clinic_logo": "",
        "clinic_stamp": "",
        "country": null,
        "birth_date": null,
        "printuser": "",
        "patient_name": "",
        "patient_email": null,
        "patient_code": "",
        "gender": null,
        "patient_contact": "",
        "age": null,
        "age_unit": null,
        "printDate": null,
        "date": null,
        "temperature": null,
        "pressure": null,
        "weight": null,
        "user": "",
        "serviceName": "",
        "serviceType":null,
        "clinicNotes": [],
        "all_tests": [],
        "notesVersion": null,
        "all_drugs": [],
        "all_procedures": [],
        "payments": {
            "amount": 0,
            "paid": 0,
        },
        "show_payments": false,
        "pyament_setting": 0
    }
]
     },
    CLEAR_SINGLE_RSULT(state) {
        state.single_result = [{
            "clinic_name": "",
            "clinic_address": "",
            "clinic_contact": "",
            "clinic_email": "",
            "spouse": "",
            "clinic_logo": "",
            "clinic_stamp": "",
            "physician": "",
            "reviewer": "",
            "comment": "",
            "printuser": "",
            "technician": "",
            "country": "",
            "test": "",
            "result_type": "",
            "resultoptions": [{
                "option_name": "",
                "result_code": "",
                "result_value": "",
                "comment": "",
                "flag": "",
                "result_symbol": "",
                "range": " - ",
                "unit": ""
            }],
            "samples": [{
                "sample_id": "",
                "sample_name": "",
                "test_name": "",
                "pick_time": "",
                "receive_time": ""
            }],
            "patient_name": "",
            "birth_date": "",
            "patient_code": "",
            "gender": "",
            "patient_contact": "",
            "print_date": "",
            "age": "",
            "patient_village": "",
            "facility": "",
            "date": "",
            "result_date": "",
            "review_date": "",
            "temperature": "",
            "pressure": "",
            "weight": ""
        }]
    },
    CLEAR_ALL_RSULT: (state) => state.all_results = [],
    CLEAR_PRINT_REPORT: (state) => state.print_report = [],
    SET_PRINT_ANTEID(state, newValue) { state.print_report_anteid = newValue },
    SET_PAYMENTSREPORT: (state, newValue) => state.payments = newValue,
    SET_PATIENT_PAYMENTSREPORT: (state, newValue) => state.patient_payments = newValue,
    SET_RESULT_SAVE_STATUS: (state, newValue) => state.result_save_status = newValue,

};
export const actions = {
    fetchPersonalShiftReport({ commit }) {
        axios.get('myshifts').then(ps_res => {
            commit('SET_PERSONAL_SHIFT_REPORT', ps_res.data)
        })
    },
    fetchVisitReport({ commit }, payload) {
         commit('SET_VISIT_REPORT_Temp')
         commit('SET_VISIT_REPORT_STATUS',true)
        axios.get(`patient_report/${payload.pid}/${payload.visit}/${payload.service}`).then(ps_res => {
            commit('SET_VISIT_REPORT', ps_res.data)
            commit('SET_VISIT_REPORT_STATUS',false)
        })
    },
    fetchCashFlow({ commit }) {
        axios.get('cashflow').then(ab_res => {
            commit('SET_CASHFLOW', ab_res.data)
        })
    },
    fetchIncome({ commit }) {
        axios.get('income').then(ab_res => {
            commit('SET_INCOME', ab_res.data)
        })
    },
    fetchPaymentReport({ commit }) {
        axios.get('payment_report').then(pr_res => {
            commit('SET_PAYMENT_REPORT', pr_res.data)
        })
    },
    fetchPatientPaymentReport({ commit }, id) {
        axios.get(`patient_statement/${id}`).then(pr_res => {
            commit('SET_PATIENT_PAYMENTSREPORT', pr_res.data)
        })
    },
    fetchDailyPayReport({ commit }) {
        axios.get('daily_payment_report').then(pr_res => {
            commit('SET_DAILY_PAY_REPORT', pr_res.data)
        })
    },
    fetchServiceAnalysis({ commit }) {
        axios.get('service_demand').then(sa_res => {
            commit('SET_SERVICE_ANALYSIS', sa_res.data)
        })
    },
     fetchExpense_Cat_Analysis({ commit }) {
        axios.get('expense_cat_report').then(sa_res => {
            commit('SET_EXPESE_CAT_ANALYSIS', sa_res.data)
        })
    },
    filterExpense_Cat_Analysis({ commit },payload) {
        commit('SET_EXPESE_CAT_ANALYSIS_STATUS',true)
        axios.post('expense_cat_report_filter',payload).then(res => {
            commit('SET_EXPESE_CAT_ANALYSIS_STATUS', false)
            commit('SET_EXPESE_CAT_ANALYSIS_FILTER', res.data)
        })
    },
    
    fetchSingleResult({ commit }, toPrint) {
        commit('CLEAR_SINGLE_RSULT')
        axios.get(`result_slip/${toPrint.visit}/${toPrint.test}`).then(single => {
            commit('SET_SINGLE_RESULT', single.data)
        })
    },
    
    fetchTestResultDetails({ commit }, toPrint) {
        commit('CLEAR_TEST_RESULT_DETAIL')
        axios.get(`get_test_result_details/${toPrint.visit}/${toPrint.test}`).then(single => {
            commit('SET_TEST_RESULT_DETAIL', single.data)
        })
    },
    printAntenatalVisitReport({ commit }, ante_vist) {
        commit('CLEAR_ALL_RSULT')
        axios.get(`atenatalReportPrint/${ante_vist}`).then(res => {
            commit('SET_PRINT_ANTENATAL_VISIT_REPORT', res.data)
        })
    },
    fetchAntenatalVisitData({ commit }, visit_id) {
        commit('CLEAR_PRINT_REPORT')
        axios.get(`atenatalReportData/${visit_id}`).then(res => {
            commit('SET_PRINT_ANTEID', res.data)
        })
    },
    fetchAllResults({ commit }, toPrint) {
        commit('CLEAR_ALL_RSULT')
        axios.get(`allresults/${toPrint.visit}`).then(all => {
            commit('SET_ALL_RESULT', all.data)
        })
    },
    fetchFacilityVisitReport({ commit }) {
        axios.get(`facility_visit_report`).then(all => {
            commit('SET_FACILITY_VISIT_REPORT', all.data)
        })
    },
    fetchLabPerformanceReport({ commit }) {
        axios.get(`lab_performance_report`).then(all => {
            commit('SET_LAB_PERFORMANCE_REPO', all.data)
        })
    },
    filterFacilityVisitReport({ commit }, payload) {
        commit('SET_FACILITYVISITREPORTSTATUS', true)
        axios.post(`filter_facility_visit_report`, payload).then(all => {
            commit('SET_FACILITY_VISIT_REPORT', all.data)
            commit('SET_FACILITYVISITREPORTSTATUS', false)
        })
    },

    fetchIncompleteDosageReport({ commit }) {
        axios.get(`incomplete_dosage`).then(res => {
            commit('SET_INCOMPELETE_DOSAGE_REPORT', res.data)
        })
    },
    fetchAntenatalVisitReport({ commit }) {
        axios.get(`atenatal_visits_report`).then(res => {
            commit('SET_ANTENATAL_VISIT_REPORT', res.data)
        })
    },
    fetchPrescriptionReport({ commit }) {
        axios.get(`prescription_report`).then(res => {
            commit('SET_PRESCRIPTION_REPORT', res.data)
        })
    },
        fetchDispensedReport({ commit }) {
        axios.get(`dispensed_report`).then(res => {
            commit('SET_DISPENSED_REPORT', res.data)
        })
    },

    // EMAIL RESULTS 
    emailSingleResult({ commit }, payload) {
        commit('SET_SINGLE_RESULT_EMAIL_STATUS', true)
        axios.post(`email_single_report/${payload.visit}/${payload.test}`).then(resp => {
            commit('SET_SINGLE_RESULT_EMAIL_MSG', resp.data)
            commit('SET_SINGLE_RESULT_EMAIL_STATUS', false)
        })
    },
    // EMAIL RESULTS 
    emailAllResult({ commit, dispatch }, visit_id) {
        commit('SET_ALL_RESULT_EMAIL_STATUS', true)


        axios.get(`email_all_report/${visit_id}`).then(resp => {
            commit('SET_ALL_RESULT_EMAIL_STATUS', false)
            commit('SET_ALL_RESULT_EMAIL_MSG', resp.data)
        })
        setTimeout(() => {
            commit('SET_ALL_RESULT_EMAIL_STATUS', false);
            commit('SET_ALL_RESULT_EMAIL_MSG', "Results Email sent successfully");
            let message = { 'msg': "Results Email sent successfully" }
            dispatch('notification/success', message, { root: true })
        }, 2000);
    },
    fetchPayments({ commit }) {
        axios.get('patient_performance_report').then(res => {
            commit('SET_PAYMENTSREPORT', res.data)
        })
    },
    fetchDiscountReport({ commit }) {
        axios.get('discount_report').then(res => {
            commit('SET_DISCOUNT_REPORT', res.data)
        })
    },

    fetchDiagnosisReport({ commit }) {
        axios.get('diagnosis').then(res => {
            commit('SET_DIAGNOSIS_REPORT', res.data)
        })
    },

    fetchGraph({ commit }, payload) {
        axios.post('departmental_report', payload).then(gres => {
            commit('SET_GRAPH', gres.data)
        })
    },

    fetchdepartmentGraph({ commit }, payload) {
        axios.post('per_department_analysis', payload).then(gres => {
            commit('SET_DEP_GRAPH', gres.data)
        })
    },

    fetchPositivity({ commit }, payload) {
        axios.post('positivity', payload).then(gres => {
            commit('SET_POSITIVITY', gres.data)
        })
    },

    fetchTestPositivity({ commit }, payload) {
        axios.post('test_positivity', payload).then(gres => {
            commit('SET_TEST_POSITIVITY', gres.data)
        })
    },
    editDefinedResults({ commit }, payload) {
        axios.post('test_positivity', payload).then(gres => {
            commit('SET_TEST_POSITIVITY', gres.data)
        })
    },
    
    saveEditDefinedResults({ commit }, payload) {
         commit('SET_RESULT_SAVE_STATUS',true)
        axios.post('save_edit_defined_results', payload).then(() => {
            commit('SET_RESULT_SAVE_STATUS',false)
        })
    },
      saveEditParameterResults({ commit }, payload) {
         commit('SET_RESULT_SAVE_STATUS',true)
        axios.post('save_edit_parameter_results', payload).then(() => {
            commit('SET_RESULT_SAVE_STATUS',false)
        })
    },
};